module.exports = __webpack_public_path__ + "img/technology.67ab3dc9.jpg";